﻿$.fn.dxCtrlRadioButton = function custom_dxCtrlRadioButton(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-ctrlradiobutton");
        this.instance = new cdxCtrlRadioButton(this, option);
    }
    return this;
}

window.cdxCtrlRadioButton = function (container, option) {
    var Me = this;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return dx.option(name);
        }
        else {
            option[name] = value;
            if (name == "color") mMajColor()
        }
    }


    var dx = null;
    var $DivLabel = null;
    function mConstruit() {
        container.empty();
        // layout : 'horizontal' (défaut, boutons côte à côte) ou 'vertical' (boutons empilés)
        var vertical = option.layout == 'vertical'

        container.off("click")
        container.on("click", function (ev) {
            if (option.disablePropagation && typeof ev != "undefined") { ev.preventDefault(); ev.stopPropagation(); }
        })

        option.dataSource.forEach(function (itemData, idx) {
            if (typeof itemData.visible == 'undefined' || itemData.visible) {
                var itemContainer = $("<div class='dx-button' style='display:inline-flex;align-items:center;justify-content:center;border-radius:0;border:2px solid transparent;box-sizing:border-box;height:100%;'><div style='margin:0 5px;text-overflow:ellipsis;white-space:nowrap;overflow:hidden;font-weight:bold;' class='itemelement'></div ></div > ").appendTo(container)
                itemContainer.on("mouseenter", function () { mouseEnter(itemContainer) })
                itemContainer.on("mouseleave", function () { mouseLeave(itemContainer) })
                if (typeof option.minWidth != 'undefined') itemContainer.css("min-width", option.minWidth + 'px')
                if (typeof option.height != 'undefined') itemContainer.css("height", option.height + 'px')
                if (typeof option.width != 'undefined') itemContainer.css("width", option.width + 'px')
                else if (vertical) { itemContainer.css("width", "100%") }
                else { itemContainer.css("width", (100 / option.dataSource.length) + "%") }
                if (vertical) {
                    itemContainer.css("display", "flex")          // un bouton par ligne
                    if (typeof option.height == 'undefined') {
                        itemContainer.css({ "height": "auto" })
                    }
                }
                //if (typeof option.color != 'undefined') itemContainer.css("color", option.color)
                if (itemData.disabled || option.disabled) {
                    itemContainer.addClass("dx-state-disabled");
                    itemContainer.removeClass("state-hover");
                    itemContainer.off("mouseenter")
                    itemContainer.off("mouseleave")
                    //if (typeof option.color != 'undefined') { itemContainer.css("color", option.color.replace("rgb(", "rgba(").replace(")", ",0.5)")) }
                    //else { itemContainer.css("color", theme.color.replace("rgb(", "rgba(").replace(")", ",0.5)")) }
                }
                mMajColor(itemData)
                var itemElement = $(itemContainer.find(".itemelement"))
                if (typeof option.itemTemplate != 'undefined') {
                    option.itemTemplate(itemData, idx, itemElement)
                } else {
                    if (typeof itemData == 'object') { //objet
                        itemElement.parent().attr("title", (itemData.hint ? itemData.hint : itemData.text))
                        itemElement.text(itemData.text)
                    } else { //string
                        itemElement.parent().attr("title", itemData)
                        itemElement.text(itemData)
                    }

                }
                if (option.dataSource.filter(function (item) { return typeof item.visible == 'undefined' || item.visible }).length == 1) { itemContainer.css("border-radius", "5px") }
                else if (idx == option.dataSource.indexOf(option.dataSource.filter(function (item) { return typeof item.visible == 'undefined' || item.visible })[0])) { itemContainer.css("border-radius", vertical ? "5px 5px 0 0" : "5px 0 0 5px") }
                else if (idx == option.dataSource.indexOf(option.dataSource.filter(function (item) { return typeof item.visible == 'undefined' || item.visible })[option.dataSource.filter(function (item) { return typeof item.visible == 'undefined' || item.visible }).length - 1])) { itemContainer.css("border-radius", vertical ? "0 0 5px 5px" : "0 5px 5px 0") }
                if (typeof itemData.css != "undefined") itemContainer.css(itemData.css)
                if (option.value == itemData) { itemContainer.css("background-color", theme.backgroundcolorAccent) }
                else { itemContainer.css("background-color", theme.backgroundcolorTooltip) }

                if (!itemData.disabled && !option.disabled) {
                    itemContainer.on("mousedown", function () { itemContainer.css("border", "2px solid " + theme.color) })
                    itemContainer.on("mouseup", function () {
                        window.setTimeout(function () { itemContainer.css("border", "2px solid transparent") }, 250);
                    })
                    itemContainer.on("click", function (ev) {
                        if (option.disablePropagation && typeof ev != "undefined") { ev.preventDefault(); ev.stopPropagation(); }
                        container.find(".dx-button").css("background-color", "")
                        if (option.allowAnnuleSelection) {
                            if (option.value == itemData) {
                                option.value = null
                            } else {
                                option.value = itemData
                                itemContainer.css("background-color", theme.backgroundcolorAccent)
                            }
                        } else {
                            option.value = itemData
                            itemContainer.css("background-color", theme.backgroundcolorAccent)
                        }
                        if (typeof option.onValueChanged != 'undefined') { option.onValueChanged({ value: option.value, component: Me }) }
                        else { itemContainer.css("background-color", theme.backgroundcolorTooltip) }
                        mouseEnter(itemContainer)
                        mConstruit()
                    })
                }
            }
        })

        if (option.labelMode == "floating") {
            container.css({ "position": "relative", "padding-top": "15px" })
            $DivLabel = $('<div class="dx-texteditor-label" style="left: 16px;"><div class="dx-label-before" style="width: 0px;"></div><div class="dx-label"><span data-mark="">' + option.label + '</span></div><div class="dx-label-after"></div></div>').appendTo(container)
        }

        if (typeof option.txtTooltip != 'undefined' && option.txtTooltip.length > 0) {
            container.attr("title", option.txtTooltip.remplacerTout("<br/>", "%cr%"))
            //tt = $("<div/>").appendTo("body").dxCtrlTooltipHoverTarget({ target: container, position: "top", contentTemplate: function (contentElement) { $("<div style='font-size:110%;'>" + option.txtTooltip + "</div>").appendTo(contentElement); } }).dxCtrlTooltipHoverTarget("instance");
        }

        if (typeof option.onContentReady != 'undefined') option.onContentReady({ component: Me, element: container })
    }

    function mMajColor(itemData) {
        if (typeof itemData == 'undefined') { option.dataSource.forEach(function (itemDataTrait, idx) { mMajColorItemData(itemDataTrait) }) }
        else { mMajColorItemData(itemData) }

        function mMajColorItemData(itemDataForColor) {
            var idx = option.dataSource.indexOf(itemDataForColor)
            var itemContainer = $(container.find(".dx-button")[idx])
            if (typeof option.color != 'undefined') itemContainer.css("color", option.color)
            if (itemDataForColor.disabled || option.disabled) {
                if (typeof option.color != 'undefined') { itemContainer.css("color", option.color.replace("rgb(", "rgba(").replace(")", ",0.5)")) }
                else { itemContainer.css("color", theme.color.replace("rgb(", "rgba(").replace(")", ",0.5)")) }
            }
        }
    }

    function mouseEnter(itemContainer) {
        var color = itemContainer.css("background-color")
        if (color.startsWith("rgb(")) { itemContainer.css("background-color", color.replace("rgb(", "rgba(").replace(")", ",0.3)")) }
        else {
            var r = color.split(",")[0].replace("rgba(", "")
            var v = color.split(",")[1]
            var b = color.split(",")[2]
            var opacity = color.split(",")[3].replace(")", "")
            itemContainer.css("background-color", "rgba(" + r + "," + v + "," + b + ",0.3)")
        }
    }
    function mouseLeave(itemContainer) {
        var color = itemContainer.css("background-color")
        if (color.startsWith("rgb(")) { itemContainer.css("background-color", color.replace("rgb(", "rgba(").replace(")", ",1)")) }
        else {
            var r = color.split(",")[0].replace("rgba(", "")
            var v = color.split(",")[1]
            var b = color.split(",")[2]
            var opacity = color.split(",")[3].replace(")", "")
            itemContainer.css("background-color", "rgba(" + r + "," + v + "," + b + ",1)")
        }
    }

    this.mReload = function () { mConstruit(); }

    mConstruit();

    this.component = function () { return dx; }
    this.element = function () { return container; }
}